/**
 * Returns the THD customer object from the window, or an empty object if not available.
 * Only call this function inside useEffect or event handlers to avoid SSR hydration mismatch.
 */
export const getThdCustomer = () => {
  if (typeof window === 'undefined') return {};
  return window.THDCustomer?.default || {};
};

export const isGuest = () => {
  if (typeof window === 'undefined') return true;
  if (!window.THDCustomer?.default) return true;
  return !window.THDCustomer.default.isLoggedIn;
};